module.exports = __webpack_public_path__ + "static/media/medial-nonflexion-up-2.f2ebad7b.png";